/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createIngestBusinessCustomerWithContractOrchestrationResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type IngestBusinessCustomerWithContractOrchestrationResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /ingests/business-customers
 */
export interface BusinessCustomersRequestBuilder extends BaseRequestBuilder<BusinessCustomersRequestBuilder> {
    /**
     * IngestBusinessCustomers
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<IngestBusinessCustomerWithContractOrchestrationResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<BusinessCustomersRequestBuilderPostQueryParameters> | undefined) : Promise<IngestBusinessCustomerWithContractOrchestrationResult | undefined>;
    /**
     * IngestBusinessCustomers
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<BusinessCustomersRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * IngestBusinessCustomers
 */
export interface BusinessCustomersRequestBuilderPostQueryParameters {
    sendWelcomeMessage?: boolean;
    verifyOnly?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const BusinessCustomersRequestBuilderUriTemplate = "{+baseurl}/ingests/business-customers{?sendWelcomeMessage*,verifyOnly*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const BusinessCustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BusinessCustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createIngestBusinessCustomerWithContractOrchestrationResultFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
